export default {
  title: {
    index: 'RPA Dashboard',
    task: {
      detail: 'Bot Task Detail',
      add: 'Add Bot Task Account',
      edit: 'Edit Bot Task Account'
    }
  },
  tab: 'RPA',
  label: {
    job: 'Jobs',
    resume: 'Resume',
    '51job': '51 job.com',
    liepin: 'Liepin',
    zhilian: 'Zhilian',
    rpaList: 'RPA List',
    legacyTasks: 'Legacy Tasks',
    newTasks: 'New Tasks',
    accountInfo: 'Account Info',
    bind: 'Bind AJINGA',
    addAccount: 'Add Account',
    editAccount: 'Edit Account',
    memberName: '51 Member Name',
    companyName: 'Company Name',
    account: 'Account',
    password: 'Password',
    featureType: 'Feature Type',
    isEnabled: 'Is Enabled',
    channel: 'Channel',
    postingJob: 'Posting Job',
    resumeDownload: 'Download Resume',
    resumeDownloadListTitle: 'Resume Download',
    restarting: 'Restarting',
    ipAddress: 'Internal IP',
    date: {
      days: 'Day',
      hour: 'Hour',
      min: 'Min'
    },
    postedJob: {
      new: 'New Jobs Posted',
      close: 'Jobs Closed'
    },
    inQueueJob: {
      new: 'New Jobs In Queue',
      close: 'Closed Jobs in Queue'
    },
    downloadResume: {
      downloaded: 'Resumes Downloaded',
      handled: 'Resumes Uploaded',
      gap: 'Resume Gap'
    },
    bot: {
      totalBots: 'Total Bots',
      currentBots: 'Current Active Bots',
      needVerifyBots: 'Bots Needing Verification',
      errorBots: 'Bot With Errors'
    },
    table: {
      header: {
        companyAccount: 'Company/Account',
        channel: 'Channel',
        type: 'Type',
        status: 'Status',
        action: 'Action',
        view: 'View',
        onOff: 'On/Off',
        resumeName: 'Resume Name',
        candidateName: 'Candidate Name',
        reqId: 'Job ID',
        downloadTime: 'Download Time',
        uploadToAjingaTime: 'Upload to Ajinga time',
        emailSubject: 'Email Subject'
      },
      date: {
        days: 'day',
        hour: 'hour',
        min: 'min'
      }
    },
    currentStatus: 'Current Status: {status}',
    jobCompany: 'Resume Job Company(s)',
    ignoreNoIdJob: 'Ignore NO AJINGA JOB ID / NO 3rd ATS ID Job',
    importResumeToClosedJob: 'Import Resume To Closed Job'
  },
  placeholder: {
    searchCompanyById: 'Input ID to search company',
    salary: {
      min: 'Min Salary',
      max: 'Max Salary'
    },
    search: {
      taskStatus: 'Account Status',
      launcherStatus: 'Bot Status',
      featureType: 'Feature Type',
      channel: 'Channel',
      company: 'Company',
      keywords: 'Account Or Company Name'
    }
  },
  btn: {
    status: {
      enable: 'Enable',
      disable: 'Disable'
    },
    restart: 'Restart',
    add: 'Add',
    needOperate: 'Need Operate',
    download: 'Download',
    return: 'Return'
  },
  message: {
    pleaseSelect: 'Please Select',
    pleaseInput: 'Please Input',
    operatorConfirmMessage: 'Do you confirm the operation?',
    operatorConfirm: 'Yes',
    operatorCancel: 'Cancel',
    pleaseSelectCompany: 'Please Select Company First',
    ipAddressError: 'IP Address Error'
  },
  dayRange: {
    0: 'Today',
    7: '7 days',
    15: '15 days',
    30: '30 days'
  },
  featureType: {
    DOWNLOAD_RESUME: 'Retrieval Bot',
    JOB_POSTING: 'Posting Bot',
    SHI_XI_SENG_SAVE_RESUME: 'Shixiseng Email Resume Bot',
    GET_JOB_DATA: 'Sync Job PV/UV'
  },
  channelName: {
    JOB_51: '51 job',
    ZHI_LIAN: 'Zhilian',
    LIE_PIN: 'Liepin',
    SHI_XI_SENG: 'Shixiseng',
    YI_MAI_TONG_DAO: 'Yimaitongdao'
  },
  actionType: {
    START: 'Start',
    STOP: 'Close',
    RESTART: 'Re-Start',
    VERIFY: 'Verify'
  },
  taskStatus: {
    ON: 'On',
    OFF: 'Off',
    DISABLED: 'Disabled'
  },
  launcherDisplayStatus: {
    ACTIVE: 'Active',
    IN_QUEUE: 'Waiting',
    WAIT_VERIFY: 'Need Verification',
    CLOSED: 'Closed',
    EXITED_ERROR: 'With Error',
    UNKNOWN: 'Unknown'
  }
}
